import React, { Component } from 'react';
import Option from './option';

class SelectProps<T extends number | string> {
    value?: T;
    name?: string;
    label?: string;
    disabled?: boolean;
    errorMessage?: string;
    options?: Array<Option<T>>;
    onChange?: (t: T) => void;
}

class SelectState { }

class Select<T extends number | string> extends Component<SelectProps<T>, SelectState> {

    private handleOnChange = (e: React.FormEvent<HTMLSelectElement>) => {
        if (this.props.onChange) {
            const { selectedIndex } = e.currentTarget;
            const selectedOption = this.props.options![selectedIndex];
            this.props.onChange(selectedOption.value);
        }
    }

    render() {
        const value = this.props.value || '';
        const name = this.props.name || '';
        const disabled = !!this.props.disabled;
        const options = this.props.options || [];
        const id = Math.random().toString(36).substring(2);
        let label = <></>;

        if (this.props.label) {
            label = <label htmlFor={id} className={"label" + (this.props.errorMessage ? " is-danger" : "")}>{this.props.label}</label>;
        }

        let i = 0;

        return (
            <div className="field">
                {label}
                <div className="control">
                    <div className={"select form-select" + (this.props.errorMessage ? " is-danger" : "")}>
                        <select disabled={disabled} value={value} onChange={this.handleOnChange} name={name} id={id}>
                            {
                                options.map((option) => {
                                    return <option value={option.value} key={i++}>{option.label}</option>;
                                })
                            }
                        </select>
                    </div>
                </div>
                {
                    this.props.errorMessage && <p className="help is-danger">{this.props.errorMessage}</p>
                }
            </div>
        );
    }
}

export default Select;
